import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useServiceWorkerUpdate = () => {
  const location = useLocation();

  // Function to check for service worker updates
  const checkForUpdates = () => {
    // Use the global function if available, otherwise fallback to direct call
    if (window.checkForSWUpdates) {
      window.checkForSWUpdates();
    } else if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
      // Fallback method
      navigator.serviceWorker.ready.then((registration) => {
        if (registration) {
          console.log('SW: Checking for updates on navigation (fallback)...');
          registration.update().then(() => {
            console.log('SW: Update check completed (fallback)');
          }).catch((error) => {
            console.log('SW: Update check failed (fallback):', error);
          });
        }
      });
    }
  };

  // Check for updates on every route change
  useEffect(() => {
    // Small delay to ensure the page has finished loading
    const timeoutId = setTimeout(checkForUpdates, 1000);
    
    return () => clearTimeout(timeoutId);
  }, [location.pathname]);

  // Return the check function in case manual triggering is needed
  return { checkForUpdates };
};

export default useServiceWorkerUpdate; 